import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Logo = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
    sessionStorage.removeItem("lastJobListScrollY");
    sessionStorage.removeItem("lastJobListJobId");
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{ userSelect: "none" }}
    >
      {/* Иконка */}
      <Box
        onClick={handleClick}
        sx={{
          width: 44,
          height: 44,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
          animation: "lFloat 3.5s ease-in-out infinite",
          "&:hover": {
            transform: "translateY(-3px) scale(1.12)",
            animation: "none",
          },
          "&:active": {
            transform: "translateY(0) scale(0.95)",
          },
          "& svg": {
            width: "100%",
            height: "100%",
            filter: "drop-shadow(0 2px 8px rgba(99,102,241,0.25))",
          },
        }}
      >
        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="lg" x1="0" y1="0" x2="100" y2="100">
              <stop offset="0%" stopColor="#a855f7" />
              <stop offset="50%" stopColor="#6366f1" />
              <stop offset="100%" stopColor="#06b6d4" />
            </linearGradient>
          </defs>

          {/* Briefcase */}
          <rect x="22" y="40" width="56" height="36" rx="6" stroke="url(#lg)" strokeWidth="3.5" fill="none" />
          <path d="M37 40V30a2 2 0 012-2h22a2 2 0 012 2v10" stroke="url(#lg)" strokeWidth="3.5" strokeLinecap="round" fill="none" />

          {/* Neural lines inside briefcase */}
          <path d="M35 52h12l4-6 4 10 4-6 12 6" stroke="url(#lg)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />

          {/* Brain wave arc above */}
          <path d="M30 28 Q38 18 50 20 Q62 18 70 28" stroke="url(#lg)" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.4" />

          {/* Nodes */}
          <circle cx="50" cy="20" r="3" fill="#a855f7">
            <animate attributeName="r" values="2;3.5;2" dur="2s" repeatCount="indefinite" />
          </circle>
          <circle cx="36" cy="56" r="2.5" fill="#6366f1">
            <animate attributeName="opacity" values="0.3;1;0.3" dur="1.5s" repeatCount="indefinite" />
          </circle>
          <circle cx="64" cy="56" r="2.5" fill="#06b6d4">
            <animate attributeName="opacity" values="0.3;1;0.3" dur="1.8s" repeatCount="indefinite" />
          </circle>

          {/* Вращающиеся частицы вокруг портфеля */}
          <g>
            <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="4s" repeatCount="indefinite" />
            <circle cx="86" cy="50" r="2.5" fill="#a855f7" opacity="0.9" />
          </g>
          <g>
            <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="5s" repeatCount="indefinite" />
            <circle cx="14" cy="50" r="2.5" fill="#06b6d4" opacity="0.9" />
          </g>
          <g>
            <animateTransform attributeName="transform" type="rotate" from="60 50 50" to="420 50 50" dur="6s" repeatCount="indefinite" />
            <circle cx="88" cy="30" r="2" fill="#fbbf24" opacity="0.8" />
          </g>
          <g>
            <animateTransform attributeName="transform" type="rotate" from="120 50 50" to="480 50 50" dur="7s" repeatCount="indefinite" />
            <circle cx="12" cy="30" r="2" fill="#6366f1" opacity="0.8" />
          </g>
          <g>
            <animateTransform attributeName="transform" type="rotate" from="180 50 50" to="540 50 50" dur="3.5s" repeatCount="indefinite" />
            <circle cx="82" cy="72" r="1.8" fill="#fff" opacity="0.6" />
          </g>
          <g>
            <animateTransform attributeName="transform" type="rotate" from="240 50 50" to="600 50 50" dur="4.5s" repeatCount="indefinite" />
            <circle cx="18" cy="72" r="1.8" fill="#fff" opacity="0.6" />
          </g>
        </svg>
      </Box>

      {/* Текст */}
      <Typography
        onClick={handleClick}
        variant="h5"
        sx={{
          fontWeight: 800,
          fontSize: "1.8rem",
          lineHeight: 1,
          letterSpacing: "-0.8px",
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          cursor: "pointer",
          transition: "all 0.3s ease",
          "&:hover": { transform: "translateY(-2px)" },
          "&:active": { transform: "translateY(0)" },
        }}
      >
        <Box component="span" sx={{ color: "#0f172a" }}>
          Job
        </Box>
        <Box
          component="span"
          sx={{
            fontWeight: 800,
            fontSize: "0.95em",
            ml: 0.5,
            background: "linear-gradient(135deg, #a855f7 0%, #6366f1 50%, #06b6d4 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
          }}
        >
          MD
        </Box>
      </Typography>

      <style>{`
        @keyframes lFloat {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-5px); }
        }
      `}</style>
    </Stack>
  );
};

export default Logo;
